function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { assert, AssertionError } from '../common/assert';

// Because modes/index.ts references this file, we have to import every model from its own file

import { CommunicationDisplayStatus } from '../models/communication-display-status';
import { ItemType } from '../models/item-type';
import { StaticFilesAccessType } from '../models/static-files-access-type';
import { DocumentEventTypes } from '../models/document-event-types';
function enumMap(lookup, modelValue) {
  if (modelValue && Object.prototype.hasOwnProperty.call(lookup, modelValue)) {
    return lookup[modelValue];
  }
  throw new AssertionError('Invalid enum value', lookup, modelValue);
}
var communicationDisplayStatusToStatusFilter = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CommunicationDisplayStatus.WaitingOnClient, 'WaitingOnClient'), CommunicationDisplayStatus.Canceled, 'Canceled'), CommunicationDisplayStatus.Completed, 'Completed'), CommunicationDisplayStatus.Received, 'Received'), CommunicationDisplayStatus.Rejected, 'Rejected'), CommunicationDisplayStatus.Sent, 'Sent');
var staticFilesAccessTypes = _defineProperty(_defineProperty(_defineProperty({}, StaticFilesAccessType.Company, 'Company'), StaticFilesAccessType.Open, 'Open'), StaticFilesAccessType.Secure, 'Secure');
var documentEventTypesFilter = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DocumentEventTypes.Accessed, 'Accessed'), DocumentEventTypes.Copied, 'Copied'), DocumentEventTypes.Created, 'Created'), DocumentEventTypes.Deleted, 'Deleted'), DocumentEventTypes.Moved, 'Moved'), DocumentEventTypes.Restored, 'Restored'), DocumentEventTypes.Trashed, 'Trashed'), DocumentEventTypes.Updated, 'Updated');
export function sort(data) {
  return data.column + ':' + data.direction;
}
export function addPermissionsCriteria(data, cascade, notify) {
  return {
    role: data.role,
    memberId: data.user.id,
    memberType: data.userType,
    cascadePermissions: cascade,
    groupType: 'Staff',
    // ??? The DTO just says this is the only option
    notify: notify
  };
}
var itemTypes = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ItemType.Project, 'Project'), ItemType.Folder, 'Folder'), ItemType.Document, 'Document'), ItemType.Link, 'Document'), ItemType.Client, 'Client');
export function itemType(type) {
  if (itemTypes[type]) {
    return itemTypes[type];
  }
  throw new AssertionError('Invalid type for API Item Type', itemTypes, type);
}
var containerTypes = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ItemType.Project, 'Projects'), ItemType.Folder, 'Folders'), ItemType.Template, 'Templates'), ItemType.Client, null), ItemType.AppGroup, null), ItemType.YearGroup, null), ItemType.Trash, null);
export function containerType(type) {
  if (containerTypes[type]) {
    return containerTypes[type];
  }
  throw new AssertionError('Invalid container type for API', 'ItemType.Project or ItemType.Folder, ItemType.Templates', type);
}
export function updateProject(model, rename) {
  var _model$year;
  return {
    id: model.id,
    name: rename !== null && rename !== void 0 ? rename : model.name,
    productType: 'DMSClientFolder',
    processingYear: (_model$year = model.year) !== null && _model$year !== void 0 ? _model$year : 1900,
    primaryAssociationId: model.parent.id,
    primaryAssociationType: itemTypes[ItemType.Client]
  };
}
export function projectOrFolderType(type) {
  var apiContainerType = containerType(type);
  assert(apiContainerType === 'Projects' || apiContainerType === 'Folders', 'Invalid containerType, only projects or folders allowed', true, type);
  return apiContainerType;
}
export function updateFolder(model, rename) {
  var apiContainerType = projectOrFolderType(model.parent.type);
  return {
    id: model.id,
    name: rename !== null && rename !== void 0 ? rename : model.name,
    containerId: model.parent.id,
    containerType: apiContainerType
  };
}
export function createProject(parent, name, year) {
  var isTemplate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return {
    name: name,
    productType: 'DMSClientFolder',
    processingYear: year !== null && year !== void 0 ? year : 1900,
    primaryAssociationId: parent.id,
    primaryAssociationType: isTemplate ? 'Firm' : 'Client'
  };
}
export function createSubRequest(model) {
  var apiContainerType = projectOrFolderType(model.containerKey.type);
  return {
    details: model.details,
    status: model.status,
    communicationStatus: model.communicationStatus,
    type: model.type,
    documents: model.documents,
    containerId: model.containerKey.id,
    containerType: apiContainerType,
    recipients: model.recipients,
    order: model.order
  };
}
export function createSubRequests(model) {
  var subRequests = [];
  model.forEach(function (subRequest) {
    return subRequests.push(createSubRequest(subRequest));
  });
  return subRequests;
}
export function createRequest(model) {
  var _model$expirationDate;
  var request = {
    status: model.status,
    subject: model.subject,
    clientId: model.clientId,
    projectId: model.projectId,
    requestType: model.requestType,
    subRequests: createSubRequests(model.subRequests),
    recipients: model.recipients,
    dueDate: model.dueDate.toISOString(),
    expirationDate: (_model$expirationDate = model.expirationDate) === null || _model$expirationDate === void 0 ? void 0 : _model$expirationDate.toISOString(),
    metadata: model.metaData
  };
  if (model.password) {
    // These aren't present on the DTO and we don't know why but they're currently being used in staff.
    /* eslint-disable @typescript-eslint/no-explicit-any */
    request.securityRequired = true;
    /* eslint-disable @typescript-eslint/no-explicit-any */
    request.securityPassword = model.password;
  }
  return request;
}
export function updateRequest(model) {
  var _model$reminderDate, _model$expirationDate2;
  return {
    subject: model.status,
    dueDate: model.dueDate.toISOString(),
    reminderDate: (_model$reminderDate = model.reminderDate) === null || _model$reminderDate === void 0 ? void 0 : _model$reminderDate.toISOString(),
    expirationDate: (_model$expirationDate2 = model.expirationDate) === null || _model$expirationDate2 === void 0 ? void 0 : _model$expirationDate2.toISOString(),
    comments: model.comments,
    status: model.status,
    clientId: model.clientId,
    projectId: model.projectId,
    metadata: model.metaData
  };
}
export function updateSubRequest(model) {
  var _model$receivedDate;
  var apiContainerType = projectOrFolderType(model.containerKey.type);
  return {
    type: model.type,
    details: model.details,
    receivedDate: (_model$receivedDate = model.receivedDate) === null || _model$receivedDate === void 0 ? void 0 : _model$receivedDate.toISOString(),
    status: model.status,
    comments: model.comments,
    containerType: apiContainerType,
    containerId: model.containerKey.id
  };
}
export function communicationStatusFilters(status) {
  return status ? status.map(function (value) {
    return enumMap(communicationDisplayStatusToStatusFilter, value);
  }) : [];
}
export function moveFolder(folderId, folderName, target) {
  var apiContainerType = projectOrFolderType(target.type);
  return {
    id: folderId,
    name: folderName,
    containerId: target.id,
    containerType: apiContainerType
  };
}
export function copyFolder(folderName, target) {
  var apiContainerType = projectOrFolderType(target.type);
  return {
    name: folderName,
    destinationContainerId: target.id,
    destinationContainerType: apiContainerType
  };
}
export function copyDocument(documentName, target) {
  var apiContainerType = projectOrFolderType(target.type);
  return {
    name: documentName,
    destinationContainerId: target.id,
    destinationContainerType: apiContainerType
  };
}
export function recentItemRequest(recentItemRequest) {
  return {
    verb: recentItemRequest.verb,
    pageSize: recentItemRequest.pageSize,
    page: recentItemRequest.page,
    getAncestors: recentItemRequest.getAncestors
  };
}
export function staticFilesAccessType(accessType) {
  if (staticFilesAccessTypes[accessType]) {
    return staticFilesAccessTypes[accessType];
  }
  throw new AssertionError('Invalid type for API Static Files Access Type', staticFilesAccessTypes, accessType);
}
export function trashDocumentRequest(key) {
  var apiContainerType = projectOrFolderType(key.parent.type);
  return {
    id: key.id,
    containerId: key.parent.id,
    containerType: apiContainerType
  };
}
export function documentEventTypes(eventType) {
  var result = eventType === null || eventType === void 0 ? void 0 : eventType.map(function (value) {
    return enumMap(documentEventTypesFilter, value);
  });
  return result ? result : [];
}
